import {
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import type { Alert } from '../../app/types';
import PageSection from '../shared/PageSection';

export default function AlertsPage({ alerts }: { alerts: Alert[] }) {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [previewTitle, setPreviewTitle] = useState<string | null>(null);

  const openPreview = (url: string | undefined, title: string) => {
    if (!url) {
      return;
    }
    setPreviewUrl(url);
    setPreviewTitle(title);
  };

  const closePreview = () => {
    setPreviewUrl(null);
    setPreviewTitle(null);
  };

  return (
    <PageSection title="Alerts" subtitle="Open and historical alert records generated by the face-match worker.">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Created</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Camera</TableCell>
            <TableCell>Subject</TableCell>
            <TableCell>Summary</TableCell>
            <TableCell>Thumbnail</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {alerts.map((alert) => (
            <TableRow key={alert.alertId}>
              <TableCell>{new Date(alert.createdAt).toLocaleString()}</TableCell>
              <TableCell><Chip size="small" label={alert.status} /></TableCell>
              <TableCell>{alert.cameraId}</TableCell>
              <TableCell>{alert.subjectId}</TableCell>
              <TableCell>{alert.summary}</TableCell>
              <TableCell>
                {alert.detection?.cropThumbnailUrl ? (
                  <img
                    src={alert.detection.cropThumbnailUrl}
                    alt="Alert thumbnail"
                    style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 6, cursor: 'pointer' }}
                    onClick={() =>
                      openPreview(alert.detection?.cropUrl ?? alert.detection?.cropThumbnailUrl, 'Alert crop')
                    }
                  />
                ) : (
                  'Pending crop'
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Dialog open={Boolean(previewUrl)} onClose={closePreview} maxWidth="md" fullWidth>
        <DialogTitle>{previewTitle ?? 'Alert crop'}</DialogTitle>
        <DialogContent>
          {previewUrl ? (
            <img src={previewUrl} alt="Alert crop" style={{ width: '100%', height: 'auto', borderRadius: 8 }} />
          ) : (
            <Typography color="text.secondary">Preview unavailable.</Typography>
          )}
        </DialogContent>
      </Dialog>
    </PageSection>
  );
}
